var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"IconTextButton-outline",attrs:{"outlined":"","small":"","elevation":"0","disabled":_vm.isDisabled},on:{"click":_vm.buttonClick}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.buttonText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }